import React, { useState, useEffect } from 'react';
import AceModule from 'react-ace';
import 'ace-builds/src-noconflict/mode-json.js';
import 'ace-builds/src-noconflict/theme-github.js';
import { Pane } from '@leverege/ui-elements';
const AceEditor = AceModule.default;
export default function ObjectEditor(props) {
  const {
    attr,
    onChange,
    data
  } = props;
  const value = attr.get(data);
  const [newValue, setNewValue] = useState(JSON.stringify(value, null, 2));
  useEffect(() => {
    setNewValue(JSON.stringify(value, null, 2));
  }, [value]);
  const onBlur = evt => {
    let newParsedValue = value;
    try {
      newParsedValue = JSON.parse(newValue);
    } catch (err) {
      console.warn('we should fail validation here..');
    }
    onChange({
      value: newParsedValue,
      data: {
        attribute: attr
      },
      original: evt
    });
  };
  return /*#__PURE__*/React.createElement(Pane, {
    style: {
      width: '100%',
      height: '300px'
    }
  }, /*#__PURE__*/React.createElement(AceEditor, {
    style: {
      fontFamily: 'monospace',
      flex: 1
    }
    // ref={ace}
    ,
    mode: "json",
    width: "100%",
    height: "100%",
    theme: "github",
    tab: 2,
    focus: true,
    value: newValue,
    name: "json-editor",
    onChange: setNewValue,
    editorProps: {
      $blockScrolling: true
    },
    onBlur: onBlur
  }));
}